import { createRouter, createWebHashHistory } from "vue-router"

const routes = [
  {
    path: '/',
    component: () => import('../views/home.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/login',
    component: () => import('../views/login.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/pay',
    component: () => import('../views/pay.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/functionIntroduce',
    component: () => import('../views/functionIntroduce.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/concatUs',
    component: () => import('../views/concatUs.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/reguser',
    component: () => import('../views/reguser.vue'),
    meta: {
      keepAlive: false,
      isReguser: true,
    }
  },
  {
    path: '/forgetPwd',
    component: () => import('../views/forgetPwd.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/userinfo',
    component: () => import('../views/userinfo.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/experimentReport',
    component: () => import('../views/experimentReport.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/taskList',
    component: () => import('../views/taskList.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/taskListAll',
    component: () => import('../views/taskListAll.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/userHelp',
    component: () => import('../views/userHelp.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/addTask',
    component: () => import('../views/addTask.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/addTask'
    }
  },
  {
    path: '/problemHelp',
    component: () => import('../views/problemHelp.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/billApplication',
    component: () => import('../views/billApplication.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/billApplication'
    }
  },
  {
    path: '/frontPage',
    component: () => import('../views/frontPage.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/frontPage'
    }
  },
  {
    path: '/randomBlock',
    component: () => import('../views/randomBlock.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/randomBlock'
    }
  },
  {
    path: '/traitSurvey',
    component: () => import('../views/traitSurvey.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/traitSurvey'
    }
  },
  {
    path: '/productComparison',
    component: () => import('../views/productComparison.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/productComparison'
    }
  },
  {
    path: '/resultDownload',
    component: () => import('../views/resultDownload.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/resultDownload'
    }
  },
  {
    path: '/templateDownload',
    component: () => import('../views/templateDownload.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/templateDownload'
    }
  },
  {
    path: '/dataSummary',
    component: () => import('../views/dataSummary.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/dataSummary'
    }
  },
  {
    path: '/reportList',
    component: () => import('../views/reportList.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/reportList'
    }
  },
  {
    path: '/productComparisonReport',
    component: () => import('../views/productComparisonReport.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/productComparisonReport'
    }
  },
  {
    path: '/userReview',
    component: () => import('../views/userReview.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/userReview'
    }
  },
  {
    path: '/userManage',
    component: () => import('../views/userManage.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/userManage'
    }
  },
  {
    path: '/taskListAll',
    component: () => import('../views/taskListAll.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/taskListAll'
    }
  },
  {
    path: '/ticketIssuance',
    component: () => import('../views/ticketIssuance.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/ticketIssuance'
    }
  },
  {
    path: '/invoicingApplication',
    component: () => import('../views/invoicingApplication.vue'),
    meta: {
      keepAlive: true,
      activeMenu: '/invoicingApplication'
    }
  },
  {
    path: '/customizedServices',
    component: () => import('../views/customizedServices.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/largeGroups',
    component: () => import('../views/largeGroups.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/tableDataPersonalization',
    component: () => import('../views/tableDataPersonalization.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/genomicSelection',
    component: () => import('../views/genomicSelection.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/dingjia',
    component: () => import('../views/dingjia.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/regionalTrial',
    component: () => import('../views/regionalTrial.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/molecularFingerprint',
    component: () => import('../views/molecularFingerprint.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/HaploidQualityQontrol',
    component: () => import('../views/HaploidQualityQontrol.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/geneticallyModified',
    component: () => import('../views/geneticallyModified.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/applicationService',
    component: () => import('../views/applicationService.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
  {
    path: '/applicationSecret',
    component: () => import('../views/applicationSecret.vue'),
    meta: {
      keepAlive: false,
      isLogin: true,
    }
  },
]


const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router